<template>
  <div class="w-12/12 column px-gap py-1 m-0" :class="setColumns">
    <div>
      <div class="text-left flex items-center">
        <div
          v-if="feature.fields && feature.fields.description"
          class="align-text-bottom relative"
        >
          <svg
            class="inline mr-1/4 relative"
            :class="feature.fields.description ? 'cursor-pointer' : ''"
            v-on="
              feature.fields.description
                ? {
                    mouseenter: () => (open = !open),
                    mouseleave: () => (open = !open),
                  }
                : {}
            "
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.16663 14.1667H10.8333V9.16675H9.16663V14.1667ZM9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.16663 7.50008H10.8333V5.83342H9.16663V7.50008Z"
              fill="#00263E"
            />
          </svg>
          <Tooltip
            v-show="open === true"
            :content="get(feature, 'fields.description', '')"
          />
        </div>
        <h4 v-if="specs" class="font-semibold text-blue-dark pt-1/2">
          {{ get(feature, "fields.featureTitle", "") }}
        </h4>
        <p v-else class="text-xl inline font-normal text-blue-dark m-0">
          {{ get(feature, "fields.featureTitle", "") }}
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.background--light-gray {
  background: rgba(#c4c4c4, 0.15);
}
.label--features {
  padding-left: 56px;
  svg {
    margin-left: -40px;
  }
}
h4 {
  @media (max-width: 736px) {
    font-size: 20px;
  }
}
</style>
<script>
import get from "../mixins/get.js";
import Tooltip from "./Tooltip.vue";
export default {
  components: {
    Tooltip,
  },
  mixins: [get],
  props: {
    feature: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    i: {
      type: Number,
      required: true,
    },
    specs: {
      type: Boolean,
      required: false,
      default: false,
    },
    expandAll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  watch: {
    expandAll: "openAll",
  },
  methods: {
    openAll() {
      this.open = true;
    },
  },
  computed: {
    setColumns() {
      return [
        this.length <= 2 ? "w-[60vw] md:w-4/12" : "w-[60vw] md:w-3/12",
        this.i % 2 !== 0 && !this.specs ? "bg-gray-neutral-100" : "",
        this.specs
          ? "label--specs gray-neutral-250 border-t-1 "
          : "label--features pl-2 border-gray-neutral-250 border-b-1 ",
      ];
    },
  },
};
</script>
